export default __webpack_public_path__ + "static/media/data-by-filters-graph.17cef49f.gif";